import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.172 16H20V4H4v13.172L5.172 16ZM2 22V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4Z"
    />
  </svg>
);
export default IconCommentStrokedSizeM;
